/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Total/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Total({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/PaymentsCreateInvoice/Total"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let createInvoiceRetailItemsValueData = fromData.useDataValue({ viewPath,
context: 'create_invoice',
path: 'retail_items',
})
let createInvoiceChargesValueData = fromData.useDataValue({ viewPath,
context: 'create_invoice',
path: 'charges',
})
let aggregateData = fromHelpers.getValue(createInvoiceRetailItemsValueData, createInvoiceChargesValueData)
  return (<React.Fragment
>
<div
  data-testid="Total.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-5PPze': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mt-2-5PPze': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btc-3-5PPze': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Total"
 color={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="create_invoice.retail_items"
 data="create_invoice.charges"
 aggregate="helpers.js getValue"
 text={aggregateData}
 weight="medium"
/>
</div>
{children}
</React.Fragment>)
}